/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MinimalCampaignDto } from './minimal-campaign-dto';
import { MinimalPassDto } from './minimal-pass-dto';
import { MinimalNotificationDto } from './minimal-notification-dto';


export interface CustomerEventDto { 
    id: string;
    customerId: string;
    passId: string;
    campaignId: string;
    notificationId: string;
    type: CustomerEventDto.TypeEnum;
    properties: object;
    createdAt: string;
    pass: MinimalPassDto;
    campaign: MinimalCampaignDto;
    notification: MinimalNotificationDto;
}
export namespace CustomerEventDto {
    export const TypeEnum = {
        CampaignDisjoined: 'CAMPAIGN_DISJOINED',
        CustomerBirthday: 'CUSTOMER_BIRTHDAY',
        CampaignJoined: 'CAMPAIGN_JOINED',
        CouponAssigned: 'COUPON_ASSIGNED',
        CouponExpiring: 'COUPON_EXPIRING',
        CouponInstalled: 'COUPON_INSTALLED',
        CouponPassCreated: 'COUPON_PASS_CREATED',
        CouponUninstalled: 'COUPON_UNINSTALLED',
        CustomerCreated: 'CUSTOMER_CREATED',
        CustomerScanned: 'CUSTOMER_SCANNED',
        CustomerTapped: 'CUSTOMER_TAPPED',
        GiftCardSent: 'GIFT_CARD_SENT',
        PassCreated: 'PASS_CREATED',
        PassInstalled: 'PASS_INSTALLED',
        PassRequested: 'PASS_REQUESTED',
        PassUninstalled: 'PASS_UNINSTALLED',
        PassUpdated: 'PASS_UPDATED',
        PointsAdded: 'POINTS_ADDED',
        PointsRemoved: 'POINTS_REMOVED',
        PushCreated: 'PUSH_CREATED',
        PushFailed: 'PUSH_FAILED',
        PushSent: 'PUSH_SENT',
        RewardRedeemable: 'REWARD_REDEEMABLE',
        RewardRedeemed: 'REWARD_REDEEMED',
        RewardRefunded: 'REWARD_REFUNDED',
        TierChanged: 'TIER_CHANGED'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


